/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export const getCodeBlocks = (feature: BaseTibbit): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const currentSocket = Number(feature.getSettingValue('SOCKET'));
    const prevSocket = (currentSocket - 1).toString();
    const TEMP_NAME = feature.getSettingValue('TEMP_NAME');
    const HUM_NAME = feature.getSettingValue('HUM_NAME');
    const NAME = `${TEMP_NAME}_${HUM_NAME}`;
    const { project } = feature;
    const ID = feature.getID();
    const connectedSocket = (Number(feature.getSettingValue('SOCKET')) - 1).toString();

    blocks.push({
        location: `var_${TEMP_NAME}_update`,
        blockType: BlockType.CODE,
        template: `
var_${HUM_NAME}_update_completed(simulator.context['${ID}']['HUM_NAME'])
var_${TEMP_NAME}_update_completed(simulator.context['${ID}']['TEMP_NAME'])`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext('${ID}', {
    'HUM_NAME': ${HUM_NAME},
    'TEMP_NAME': ${TEMP_NAME}
});
    `,
    });
    return blocks;
};
